/**
 * 작성자 : 김광민
 * 날짜 : 2024.02.13
 * 기능 : 터널 관리 > 방송 장비 정보
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Root = styled.div`
  user-select: none;
  display: flex;
  gap: 0.5rem;
  background-color: var(--selected-primary);
  color: var(--text-reverse);
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  .material-symbols-rounded {
    font-size: 1.5rem;
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
  }
  .text {
    font-size: 0.875rem;
    margin-right: 0.25rem;
  }
  &:active {
    background-color: var(--filled-blue-deep);
  }
`;

type Props = {
  onClick: () => void;
};

const BroadcastWithLabelButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <Root role='button' tabIndex={0} onClick={onClick}>
      <span className='material-symbols-rounded'>podcasts</span>
      <span className='text'>{t('선택 방송 시작')}</span>
    </Root>
  );
};

export default React.memo(BroadcastWithLabelButton);
